module.exports = __webpack_public_path__ + "static/notification-groups-delete-2-93845ee89a2376f48bf29a9f5ae15ef8.png";